/* eslint-disable camelcase */
import { MenuItem, Menu, IconButton, Tooltip } from '@material-ui/core';
import React, { useState, useContext } from 'react';
import Add from '@material-ui/icons/Add';
import { FlexRowDiv } from '@mummssoftware/common-ui/style';
import {
  VFGlobalContext,
  ADD_EDITING_DATA,
} from '@mummssoftware/global-context/VFGlobalContext';
import { OrdersGlobalContext } from '@mummssoftware/global-context';
import { CPFContext } from '../../containers/Context/CPFContext';
import {
  SET_NEW_ROW,
  SET_EDIT_ROW_OPEN,
  SET_AG_ROW_EDTING_DATA,
} from '../../containers/Context/constants';
import { createOrderEntryId } from '../cells/orderEntryHelpers';
import { borderlessButtonStyle } from '../../utils/styles';
import { AddRole } from '../../utils/constant';

interface RoleGroupSelectorProps {
  rgHash: mumms.HashedRoleGroup;
  smallWidget?: boolean;
}

export const RoleGroupSelector = ({
  rgHash,
  smallWidget,
}: RoleGroupSelectorProps) => {
  const { dispatch } = useContext(CPFContext);
  const { VFordersMode, dispatchVF } = useContext(VFGlobalContext);
  const { orderType } = useContext(OrdersGlobalContext);

  const [anchorEl, setAnchorEl] = useState<any>(null);

  // logic for deciding which role groups to display in the "+" icon dropdown.
  // first check if it is one of the role groups with multiple frequencies
  // then if it is a defaultly displayed RG (if it is and it isnt one of the above don't show it in list)
  // lastly if there are no frequencies for the rg (the 1 below represents the "dummy" row)
  const getRoles = () => {
    let filteredRoleGroups = Object.values(rgHash);

    filteredRoleGroups = filteredRoleGroups.filter((roleGroup) => {
      if (!roleGroup.assignable) {
        return false;
      } else if (roleGroup.defaultRoleGroup) {
        return false;
      } else if (Object.keys(roleGroup.frequencies).length === 1) {
        return true;
      }
      return false;
    });

    const menuItems = filteredRoleGroups.map((rg) => (
      <MenuItem
        id={rg.id.toString()}
        key={rg.id.toString()}
        value={rg.id.toString()}
        onClick={() => onSelect(rg.id)}
      >
        {rg.name}
      </MenuItem>
    ));

    return menuItems;
  };

  const onSelect = (roleGroupId: number) => {
    setAnchorEl(null);
    const roleGroup = rgHash[roleGroupId.toString()];
    if (!roleGroup) return;

    // Outside order mode: just show the role row (pre-existing add-role behavior).
    if (!VFordersMode) {
      dispatch({
        type: SET_NEW_ROW,
        payload: roleGroup,
      });
      return;
    }

    // Order mode: stage a pending entry and open Edit dialog.
    // The role row is produced by applyOrderModeToRows via VForderData; no SET_NEW_ROW needed.
    const entryId = createOrderEntryId(roleGroupId);
    dispatchVF({
      type: ADD_EDITING_DATA,
      payload: {
        entryId,
        id: roleGroupId,
        name: roleGroup.name,
        createdAt: Date.now(),
        orderType,
      },
    });
    dispatch({
      type: SET_AG_ROW_EDTING_DATA,
      payload: {
        data: {
          id: `pending-${entryId}`,
          roleGroupId,
          name: roleGroup.name,
          order: roleGroup.order,
          orderEntryId: entryId,
          isOrderPending: true,
          isNewestOrderPending: true,
          rowHeight: 26,
        },
        rgHash,
      },
    });
    dispatch({
      type: SET_EDIT_ROW_OPEN,
      payload: true,
    });
  };

  const roleGroupSelectorId = `roleGroupSelector${smallWidget}`;

  const handleOpenRoleGroupSelector = () => {
    setAnchorEl(document.querySelector(`#${roleGroupSelectorId}`));
  };

  return (
    <FlexRowDiv id={roleGroupSelectorId}>
      <Tooltip title={AddRole}>
        <IconButton
          size="small"
          style={borderlessButtonStyle}
          onClick={handleOpenRoleGroupSelector}
        >
          <Add />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        keepMounted
        onClose={() => {
          setAnchorEl(null);
        }}
        style={{ maxHeight: '400px' }}
      >
        {getRoles()}
      </Menu>
    </FlexRowDiv>
  );
};
